import { z } from 'zod';

/** Contratos de Orçamentos / Planejamento (M6, escopo mínimo). */

const ymSchema = z.string().regex(/^\d{4}-\d{2}$/);

/** Limite por categoria com o realizado do mês. */
export const budgetCategorySchema = z.object({
  categoryId: z.string(),
  name: z.string(),
  color: z.string(),
  icon: z.string(),
  limitCents: z.number().int(),
  spentCents: z.number().int(),
});
export type BudgetCategory = z.infer<typeof budgetCategorySchema>;

export const budgetResponseSchema = z.object({
  month: ymSchema,
  exists: z.boolean(),
  incomeCents: z.number().int(),
  savingsPercent: z.number().int(),
  /** renda × (1 − economia%) — derivado. */
  spendingBudgetCents: z.number().int(),
  /** Σ limites por categoria. */
  plannedCents: z.number().int(),
  /** Σ gastos realizados nas categorias planejadas. */
  spentCents: z.number().int(),
  categories: z.array(budgetCategorySchema),
});
export type BudgetResponse = z.infer<typeof budgetResponseSchema>;

export const upsertBudgetBodySchema = z.object({
  incomeCents: z.number().int().nonnegative(),
  savingsPercent: z.number().int().min(0).max(100),
  categories: z.array(
    z.object({
      categoryId: z.string(),
      limitCents: z.number().int().nonnegative(),
    }),
  ),
});
export type UpsertBudgetBody = z.infer<typeof upsertBudgetBodySchema>;
